import React from 'react';
import { ResponsiveBar, ResponsiveBarCanvas } from '@nivo/bar';
import { getDataForStat, getDataKeysForStat } from 'helpers/statisticsHelpers';
import StatsAsBarChartStyle from 'components/Statistics/StatsAsBarChartStyle';


const BarChart = ({ data, displayKey, year, asCanvas = false }) => {
  const formattedData = getDataForStat(data, displayKey);
  const formattedDataKeys = getDataKeysForStat(formattedData);
  const ResponsiveBarComponent = asCanvas ? ResponsiveBarCanvas : ResponsiveBar;
  return (
    <ResponsiveBarComponent
      data={formattedData}
      keys={formattedDataKeys}
      indexBy="quarter"
      {...StatsAsBarChartStyle}
      axisLeft={{
        ...StatsAsBarChartStyle.axisLeft,
        legend: `Nombre ${displayKey === 'events' ? 'd\'évenements' : 'de participants'}`,
      }}
      axisBottom={{
        ...StatsAsBarChartStyle.axisBottom,
        legend: `Année ${year}`,
      }}
    />
  );
};

export default BarChart;



// WEBPACK FOOTER //
// ./src/components/Statistics/BarChart.js